// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { Action } from 'redux';

import { IExtractTaskInfo } from '../../../ts/models/IExtractTaskInfo';
import { ResumeExtractRefresh } from '../AppActionTypes';

export interface ResumeExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function resumeExtractRefresh(tasks: IExtractTaskInfo[]): ResumeExtractRefreshAction {
  return {
    type: ResumeExtractRefresh,
    tasks
  };
}
